import React from "react";
import "./ECLInput.css";
import { ECLNumber } from "../../../../index";

export default function ECLFloat(props) {
   return props.unit ? (
      <div>
         <label htmlFor={props.id}>
            {props.name}{" "}
            {props.required && <span className="required-input">*</span>}
         </label>
         <div className="ecl-input-container">
            <ECLNumber
               id={props.id}
               key={props.id}
               min={props.min}
               max={props.max}
               placeholder={props.placeholder}
               labelWidth={props.labelWidth}
               required={props.required}
               precision={props.precision ? props.precision : 1}
            />
            <p
               className="unit-of-measurement"
               style={props.labelWidth && { width: props.labelWidth }}
            >
               {props.unit}
            </p>
         </div>
      </div>
   ) : (
      <ECLNumber
         id={props.id}
         key={props.id}
         name={props.name}
         min={props.min}
         max={props.max}
         required={props.required}
         precision={props.precision ? props.precision : 1}
      />
   );
}
